import "slick-carousel"
  ;

(function ($) {
  "use strict"
  $(function () {
    var $slider = $(document).find(".month")
    $slider.removeClass("hide")

    $(document).on("click", ".arr", function () {
      let $currItem = $(this)
      if (!$currItem.hasClass("arr_reverse")) {
        var sliderNum = $currItem.data("slider-num"),
          prevSlideNum

        if (!!sliderNum && sliderNum > 0) {
          prevSlideNum = $slider.slick("slickCurrentSlide") - sliderNum
        } else {
          prevSlideNum = $slider.slick("slickCurrentSlide") - 7
        }
        $slider.slick("slickGoTo", prevSlideNum)
      }
    })

    $(document).on("click", ".arr_reverse", function () {
      let $currItem = $(this)
      if ($currItem.length !== 0) {
        var sliderNum = $currItem.data("slider-num"),
          nextSlideNum

        if (!!sliderNum && sliderNum > 0) {
          nextSlideNum = $slider.slick("slickCurrentSlide") + sliderNum
        } else {
          nextSlideNum = $slider.slick("slickCurrentSlide") + 7
        }

        $slider.slick("slickGoTo", nextSlideNum)
      }
    })

    $slider.slick({
      infinite: true,
      dots: false,
      arrows: false,
      slidesToScroll: 7,
      autoplay: false,
      autoplaySpeed: 5000,
      autoplayHoverPause: true,
      fade: false,
      touchThreshold: 14,
      swipeToSlide: true,
      slidesToShow: 7,
      responsive: [{breakpoint: 640, settings: {slidesToScroll: 5, slidesToShow: 5}}],
    })

    // $(".month").slick("slickGoTo", 14);

    /*if ($(document).find('.x-camp-swiper').length === 0) {
      $(".camp_category").slick({
        infinite: false,
        dots: false,
        arrows: false,
        slidesToScroll: 8,
        touchThreshold: 16,
        swipeToSlide: true,
        slidesToShow: 8,
        useTransform: true,
        cssEase: "linear",
        autoplay: false,
        speed: 0,
        prevArrow: '<div class="slick-prev slick-ar"></div>',
        nextArrow:
          '<div class="slick-next slick-ar"><svg width="8" height="10" viewbox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 5L7.41603 5.62404C7.62467 5.48494 7.75 5.25076 7.75 5C7.75 4.74924 7.62467 4.51506 7.41603 4.37596L7 5ZM0.583975 8.37596C0.239328 8.60573 0.146198 9.07138 0.375962 9.41603C0.605727 9.76067 1.07138 9.8538 1.41603 9.62404L0.583975 8.37596ZM1.41603 0.375962C1.07138 0.146198 0.605727 0.239328 0.375962 0.583975C0.146198 0.928621 0.239328 1.39427 0.583975 1.62404L1.41603 0.375962ZM6.58397 4.37596L0.583975 8.37596L1.41603 9.62404L7.41603 5.62404L6.58397 4.37596ZM7.41603 4.37596L1.41603 0.375962L0.583975 1.62404L6.58397 5.62404L7.41603 4.37596Z" fill="#CFD8DC"></path></svg></div>',
        responsive: [
          {breakpoint: 640, settings: {slidesToShow: 4, slidesToScroll: 4}},
          {breakpoint: 380, settings: {slidesToShow: 3, slidesToScroll: 3}},
        ],
      })

      window.sliderCampCombo = function sliderCampCombo() {
        $(document)
          .find(".camp_combo")
          .slick({
            infinite: false,
            dots: false,
            arrows: false,
            slidesToScroll: 5,
            touchThreshold: 10,
            swipeToSlide: true,
            slidesToShow: 5,
            useTransform: true,
            cssEase: "linear",
            autoplay: false,
            speed: 0,
            responsive: [
              {breakpoint: 840, settings: {slidesToShow: 4, slidesToScroll: 4}},
              {breakpoint: 640, settings: {slidesToShow: 3, slidesToScroll: 3}},
            ],
          })
      }

      window.sliderCampCombo();
    }*/

    $(".slider-dish_for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow:
        '<div class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewbox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve" width="512px" height="512px"><g><g><g><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12    C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084    c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864    l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"></path></g></g></g></svg></div>',
      nextArrow:
        '<div class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewbox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve" width="512px" height="512px"><g><g><g><path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12    c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028    c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265    c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"></path></g></g></g></svg></div>',
      asNavFor: ".slider-dish_nav",
    })

    $(".slider-dish_nav").slick({
      arrows: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: ".slider-dish_for",
      focusOnSelect: true,
    })
  })
})(jQuery)
